module.exports = __webpack_public_path__ + "static/media/event-card-bg-image.6be2b023.png";